var _defs, _g, _g2, _g3, _g4, _g5, _g6, _polygon, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\xCE\\xD3\\xC8_1",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1737.79 1737.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #0f172a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "675.37 678.13 548.94 551.69 548.94 551.69 689.81 625.48 702.81 569.97 418.06 420.82 566.22 703.68 675.37 678.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1059.66 675.37 1186.09 548.94 1186.1 548.93 1112.31 689.81 1167.82 702.81 1316.97 418.06 1034.1 566.22 1059.66 675.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1062.42 1059.66 1188.85 1186.09 1188.85 1186.1 1047.98 1112.31 1034.98 1167.82 1319.73 1316.97 1171.57 1034.1 1062.42 1059.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "678.13 1062.42 551.7 1188.85 551.69 1188.85 625.48 1047.98 569.97 1034.98 420.82 1319.73 703.69 1171.57 678.13 1062.42"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M944.9,185.23c318.7,35.19,572.46,288.96,607.66,607.66l42.38,9.92c-31.54-349.38-310.58-628.41-659.95-659.96l9.92,42.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.23,792.89C220.42,474.19,474.19,220.42,792.89,185.23l9.92-42.38C453.43,174.4,174.4,453.43,142.86,802.81l42.38-9.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1552.56,944.9c-35.19,318.7-288.96,572.46-607.66,607.66l-9.92,42.38c349.38-31.54,628.41-310.58,659.96-659.95l-42.38,9.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M792.89,1552.56c-318.7-35.19-572.47-288.96-607.66-607.66l-42.38-9.92c31.54,349.38,310.58,628.41,659.96,659.96l-9.92-42.38Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M345.66,755.32c17.17-79.12,51.86-151.78,99.81-213.68l-20.86-39.83c-61.71,74.55-105.04,164.83-123.01,263.83l44.07-10.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.59,972.14c18.15,99.94,62.16,190.99,124.8,265.95l20.8-39.7c-48.86-62.39-84.19-135.85-101.55-215.93l-44.05-10.31Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M755.32,1392.12c-78.68-17.07-150.98-51.47-212.67-99.02l-39.88,20.89c74.36,61.28,164.29,104.31,262.86,122.21l-10.32-44.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M982.46,1392.12l-10.32,44.07c98.57-17.9,188.5-60.93,262.87-122.21l-39.88-20.89c-61.68,47.55-133.98,81.95-212.67,99.02Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1436.19,765.65c-17.98-99-61.31-189.29-123.01-263.84l-20.86,39.83c47.96,61.91,82.65,134.57,99.81,213.69l44.07,10.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1392.15,982.46c-17.37,80.08-52.7,153.54-101.55,215.93l20.8,39.7c62.65-74.96,106.65-166,124.8-265.94l-44.05,10.31Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M982.45,345.63c80.51,17.46,154.34,53.08,216.94,102.35l39.65-20.77c-75.14-63.07-166.53-107.39-266.9-125.62l10.31,44.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M755.34,345.63l10.31-44.04c-100.37,18.23-191.77,62.54-266.91,125.62l39.65,20.77c62.61-49.27,136.43-84.89,216.95-102.35Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1033.74 1033.74 1737.79 868.89 1033.74 704.05 868.89 0 704.05 704.05 0 868.89 704.05 1033.74 868.89 1737.79 1033.74 1033.74"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "868.89 186.07 743.99 731.78 868.89 846.43 868.89 186.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "186.07 868.89 731.78 993.8 846.43 868.89 186.07 868.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "868.89 1551.72 993.8 1006 868.89 891.36 868.89 1551.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1551.72 868.89 1006 743.99 891.36 868.89 1551.72 868.89"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.4ec4ff7d1a69dcbdbfb28e3d64294296.svg";
export { ForwardRef as ReactComponent };